<div class="active-facets" *ngIf="facetsList.length">
    <wfbhsearch-active-facet *ngFor="let facet of facetsList" [field]="facet.field" [value]="facet.value"
        [label]="facet.label" [locked]="lockFacet && lockFacet == facet.field + '|' + facet.value">
    </wfbhsearch-active-facet>
    <a *ngIf="hasUnlockedFacet()" (click)="clearFacets()" class="clear-facets-link">Clear filters</a>
</div>